import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Action To Be Taken",
    "Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "John Doe",description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "Jane Smith", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "Michael Johnson",description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
    { id: 4, name: "John Doe",description:"lorem ipsum", status: "Active", actions: "Edit/Delete" },
    { id: 5, name: "Jane Smith", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 6, name: "Michael Johnson", description:"lorem ipsum", status: "Active", actions: "Edit/Delete" },
    { id: 7, name: "John Doe",description:"lorem ipsum", status: "Active", actions: "Edit/Delete" },
    { id: 8, name: "Jane Smith",description:"lorem ipsum",   status: "Inactive", actions: "Edit/Delete" },
    { id: 9, name: "Michael Johnson",description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
    { id: 10, name: "John Doe",description:"lorem ipsum", status: "Active", actions: "Edit/Delete" },
    { id: 11, name: "Jane Smith", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 12, name: "Michael Johnson",description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
    { id: 13, name: "John Doe",description:"lorem ipsum", status: "Active", actions: "Edit/Delete" },
    { id: 14, name: "Jane Smith",description:"lorem ipsum",   status: "Inactive", actions: "Edit/Delete" },
    { id: 15, name: "Michael Johnson",description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Action To Be Taken": "action_tobe_taken_name",
    "Description":"action_tobe_taken_desc",
    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };